import { Funcionalidade } from '@stt-gestao-pacs/util';

export const PAGINAS_INTERNAS = [
    { path: '/inicio', funcionalidades: [Funcionalidade.PAGINA_ALERTAS] },
    { path: '/notificacoes', funcionalidades: [Funcionalidade.PAGINA_ALERTAS, Funcionalidade.PAGINA_NOTIFICACAO] },
    { path: '/automacao', funcionalidades: [Funcionalidade.PAGINA_AUTOMACAO] },
    { path: '/pacs', funcionalidades: [Funcionalidade.PAGINA_PACS] },
    {
        path: '/dicom-hub',
        funcionalidades: [
            Funcionalidade.PAGINA_DICOM_HUB,
            Funcionalidade.PAGINA_SERVIDOR_PACS,
            Funcionalidade.PAGINA_VISUALIZADOR,
            Funcionalidade.DICOM_HUB_APP,
        ],
    },
];

export const primeiraPaginaPermitida = (rbac) => {
    if (!rbac || typeof rbac.temPermissao !== 'function') {
        return '/nao-autorizado';
    }
    const permitida = PAGINAS_INTERNAS.find(({ funcionalidades }) =>
        funcionalidades.some((f) => rbac.temPermissao(f)),
    );
    return permitida ? permitida.path : '/nao-autorizado';
};
